<template>
    <div>
        <el-page-header @back="goBack" content="版本列表管理"></el-page-header>
        <el-card class="form-container" style="margin-top: 25px" shadow="never">
            <el-button  type="primary" @click="showDetails('新增版本')">新增</el-button>
        </el-card>
        <el-card class="form-container" shadow="never">
            <div style="margin-top: 20px">
                <el-table :data="list"
                          style="width: 100%"
                          border>
                    <el-table-column label="序号" prop="id"  align="center"></el-table-column>
                    <el-table-column label="版本号" prop="versionCode"  align="center"></el-table-column>
                    <el-table-column label="版本名" prop="versionName" align="center"></el-table-column>
                    <el-table-column label="版本详情" prop="description" align="center" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button plain  type="primary" size="mini" @click="showDetails('编辑版本',scope.row)">编辑</el-button>
                            <el-button plain  type="danger" size="mini" @click="deleteCopy(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.page"
                :page-sizes="[10,20,30,40,50]"
                :page-size="page.size"
                layout="total, sizes, prev, pager, next"
                :total="page.totalElements">
        </el-pagination>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
            <el-form :model="copyEditForm" label-width="150px">
                <el-form-item label="版本号:" >
                    <el-input-number  :min="20" style="width: 300px" type="text" v-model="copyEditForm.versionCode"></el-input-number>
                </el-form-item>
                <el-form-item label="版本名:" >
                    <el-input  style="width: 300px" type="text" v-model="copyEditForm.versionName"></el-input>
                </el-form-item>
                <el-form-item label="版本详情:" >
                    <el-input  style="width: 300px"  type="textarea" v-model="copyEditForm.description"></el-input>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirm">确 定</el-button>
                    <el-button type="info" @click="cancel">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {
        saveCopy,
        deleteCopy,
        searchCopy
    } from "@/http/api";
    export default {
        name: "VersionCopy",
        data(){
            return{
                page: {
                    size: 20,
                    page: 1,
                    totalElements: null
                },
                dialogVisible: false,
                dialogTitle :'',
                list: [],
                copyEditForm: {},
                queryTrueData:{
                    order:'desc',
                    prop:'version_code'
                },

            }
        },
        methods:{
            goBack() {
                this.$router.push({path: '/versionList'})
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.search();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.search();
            },
            showDetails(title, row) {
                this.copyEditForm = {
                    "description": "",
                    "id": 0,
                    "versionCode": "",
                    "versionName": "",
                };
                this.dialogTitle = title;
                this.dialogVisible = true;
                if(row){
                    this.copyEditForm = {
                        "description": row.description ,
                        "id": row.id,
                        "versionCode": row.versionCode,
                        "versionName": row.versionName,
                    };
                }
            },
            confirm(){
                let _message = '';
                if(this.copyEditForm.versionCode===''){
                    _message = '请输入版本号'
                }else if (this.copyEditForm.versionName===''){
                    _message = '请输入版本名称'
                }
                if(_message){
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
                saveCopy(this.copyEditForm).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible = false;
                        this.search();
                    }
                })
            },
            deleteCopy(row){
                this.$confirm('此操作将永久删除该视频, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteCopy(row).then(resp=>{
                        if (resp.data.status===0){
                            this.search();
                        }
                    })
                }).catch(() => {
                })
            },
            cancel(){
                this.dialogVisible=false;
            },
            search(){
                this.queryTrueData.size = this.page.size;
                this.queryTrueData.page = this.page.page;
                searchCopy(this.queryTrueData).then(resp=>{
                    this.list=resp.data.info.content;
                    this.page.totalElements = resp.data.info.totalElements;
                });
            },
        },
        created() {
            this.search();
        }
    }
</script>

<style scoped>

</style>